module.exports = __webpack_public_path__ + "img/profile_box_visit_reason.717939c1.svg";